import React from 'react'

import { WrappedFieldProps } from 'redux-form'

import {
  InputLabel,
  MenuItem,
  FormHelperText,
  FormControl,
  Select
} from '@material-ui/core'

import useOptions, { OptionsProps } from '~/hooks/useOptions'

import { IFieldWithOptions } from '~/interfaces/shared'

interface Props extends IFieldWithOptions, WrappedFieldProps {
  label?: string
  displayError: string
  menuItemClass?: string
  optionSettings?: OptionsProps
  required?: boolean
}

const SelectField: React.FC<Props> = ({
  input: { value, name, ...input },
  meta: { touched, error },
  label,
  options: customOptions = [],
  displayError,
  menuItemClass,
  optionSettings,
  required,
  ...rest
}) => {
  const errorMessage = (touched && error) || displayError

  const { options } = useOptions({
    ...optionSettings,
    key: optionSettings?.key || name,
    options: customOptions
  })

  return (
    <FormControl
      required={required}
      variant="outlined"
      fullWidth
      error={!!errorMessage}
    >
      {label && <InputLabel id={name}>{label}</InputLabel>}

      <Select
        label={label}
        labelId={name}
        value={value}
        MenuProps={{
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left'
          },
          getContentAnchorEl: null
        }}
        required={required}
        {...input}
        {...rest}
      >
        {options?.map(({ value, label }, idx) => {
          return (
            <MenuItem key={idx} value={value} className={menuItemClass}>
              {label}
            </MenuItem>
          )
        })}
      </Select>

      {!!errorMessage && <FormHelperText>{errorMessage}</FormHelperText>}
    </FormControl>
  )
}

export default SelectField
